export default "__VITE_ASSET__KyKKmom3__"